import { module } from 'modujs'
import LocomotiveScroll from 'locomotive-scroll'
import { lazyLoadImage } from '../utils/image'
import { html } from '../utils/environment'


export default class extends module {
    constructor(m) {
        super(m)

        // Binding
        this.onResizeBind = this.onResize.bind(this)
        this.onFontsLoadedBind = this.onFontsLoaded.bind(this)
    }

    ///////////////
    // Lifecyle
    ///////////////
    init() {
        this.initScroll()
        this.bindEvents()

        if (window.isFontsLoaded) {
            this.onFontsLoaded()
        }
    }

    destroy() {
        this.scroll.destroy()
        this.unbindEvents()
        super.destroy()
    }

    ///////////////
    // Events
    ///////////////
    bindEvents() {
        window.addEventListener('resizeEnd', this.onResizeBind)
        window.addEventListener('fontsLoaded', this.onFontsLoadedBind)
    }

    unbindEvents() {
        window.removeEventListener('resizeEnd', this.onResizeBind)
        window.removeEventListener('fontsLoaded', this.onFontsLoadedBind)
    }

    ///////////////
    // Callbacks
    ///////////////
    onFontsLoaded() {
        this.scroll?.update();
    }

    onResize() {
        this.scroll?.update();
    }

    ///////////////
    // Methods
    ///////////////
    initScroll() {
        this.scroll = new LocomotiveScroll({
            el: this.el,
            smooth: false
        });

        this.scroll.on('call', (func, way, obj, id) => {
            // Using modularJS
            this.call(func[0], { way, obj }, func[1], func[2]);
        });

        this.scroll.on('scroll', (args) => {
            // Scroll class
            if (args.scroll.y > 200) {
                html.classList.add('has-scrolled')
            } else {
                html.classList.remove('has-scrolled')
            }
        })
    }

    /**
     * Lazy load the related image.
     *
     * @see ../utils/image.js
     *
     * It is recommended to wrap your `<img>` into an element with the
     * CSS class name `.c-lazy`. The CSS class name modifier `.-lazy-loaded`
     * will be applied on both the image and the parent wrapper.
     *
     * ```html
     * <div class="c-lazy o-ratio u-4:3">
     *     <img data-scroll data-scroll-call="lazyLoad, Scroll, main" data-src="http://picsum.photos/640/480?v=1" alt="" src="data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==" />
     * </div>
     * ```
     *
     * @param {LocomotiveScroll} args - The Locomotive Scroll instance.
     */
    lazyLoad(args) {
        lazyLoadImage(args.obj.el, null, () => {
            //callback
        })
    }

    toggleVideo(args) {
        let $target

        if (args.obj.target) {
            $target = args.obj.target
        } else if (args.obj.targetEl) {
            $target = args.obj.targetEl
        } else {
            return
        }

        const moduleID = $target.dataset.moduleVideoInview

        if (args.way === 'enter') {
            this.call('onEnter', null, 'VideoInview', moduleID)
        } else if (args.way === 'exit') {
            this.call('onLeave', null, 'VideoInview', moduleID)
        }
    }

    update() {
        this.scroll?.update()
    }

    scrollTo(params) {
        this.scroll?.scrollTo?.(params.target, params.options);
    }

    stop() {
        this.scroll?.stop();
    }

    start() {
        this.scroll?.start();
    }
}
